/**
 * Created by contrapro on 2018/4/16
 */

import React from 'react';
import { Component } from "react";
import { connect } from 'react-redux';
import './ScanView.css';
import { VIEW_STATE } from '../../../util/constConfig';
import { updateViewState, onShareOK, toggleSharePanel, scanResult } from "../../../actions";
import { updateJSSDK } from "../../../util/wxUtil";
import { getJSSDKSignConfigHost, getStaticHost } from '../../../util/serverUtil';

import btn1 from '../../../assets/imgs/scan_btn.png';
import bear from '../../../assets/imgs/scan_bear.png';
import joke from '../../../assets/imgs/scan_joke.png';

class ScanView extends Component {

    constructor(props) {
        super(props);

        this.onUpload = this.onUpload.bind(this);

    }

    componentDidMount() {


    }

    onUpload(e) {
        console.log('onUpload');
        //TODO scan
        const cb = (res) => {

            const result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
            // alert(result);
            const names = result.split(',');
            // const imgname = '0'+names[names.length-1]; //康老师没补0
            const imgname = names[names.length-1];

            // alert(imgname);
            this.props.scanResult(imgname);
            this.props.updateViewState(VIEW_STATE.SHARE);
        }
        window.wx.scanQRCode({
            needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ["barCode"],// ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
            success: cb,
            cancel: function (res) {
                console.log(res);
            }
        });
        // alert(1);
        e.preventDefault();
        // alert(2);
    }



    render() {
        return (
            <div className="ScanView">
                <img className="ScanView-joke" alt="" src={joke} />
                <img className="ScanView-btn1" alt="" src={btn1} onClick={this.onUpload}/>
                <div className="ScanView-footer">
                    <div className="ScanView-footer-text">
                        <p className="ScanView-footer-text-p1">
                            <span className="ScanView-footer-text-scan1">Q：</span>
                            条形码在哪扫啊？
                        </p>
                        <div className="ScanView-footer-text-div2">
                            <span className="ScanView-footer-text-scan2">A：</span>
                            <p className="ScanView-footer-text-p2">
                                条形码就在你作品纸上二维码的下方哦～ 点击屏幕上面蓝色按钮，开始扫你的专属条形码，把大作带回家吧!
                            </p>
                        </div>
                    </div>
                    <img className="ScanView-bear" alt="" src={bear} />
                </div>
            </div>
        );
    }
}


export default connect(state => ({
        viewState: state.viewStateReducer.viewState,
    }),
    dispatch => ({
        updateViewState: (sceneData) => {
            dispatch(updateViewState(sceneData))
        },
        scanResult: (filename) => {
            dispatch(scanResult(filename))
        },
    }))(ScanView)


// WEBPACK FOOTER //
// ./src/react/views/scan/ScanView.js